import { z } from "zod";

const DataSchema = z.object({
    id: z.string().uuid(),
    property_type: z.string(),
    name: z.string(),
    preferred_currency: z.string(),
    time_zone: z.string(),
    primary_email: z.string().email(),
    primary_phone_country_code: z.nullable(z.string()).optional(),
    primary_phone: z.nullable(z.string()).optional(),
    postal_code: z.nullable(z.string()).optional(),
    country: z.nullable(z.string()).optional(),
    state: z.nullable(z.string()).optional(),
    city: z.nullable(z.string()).optional(),
    street_address: z.nullable(z.string()).optional(),
    longitude: z.nullable(z.string()).optional(),
    latitude: z.nullable(z.string()).optional(),
    description: z.nullable(z.string()).optional(),
    website: z.nullable(z.string()).optional(),
    cc_emails: z.nullable(z.array(z.string().email())).optional(),
    accounting_email: z.nullable(z.string().email()).optional(),
    mobile_number_country_code: z.nullable(z.string()).optional(),
    mobile_number: z.nullable(z.string()).optional(),
    enable_cvv: z.nullable(z.coerce.number().int()).optional(),
});

export const CreatePropertyResponse = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: DataSchema,
});